import { useState } from "react"
import { useParams } from "react-router-dom"
import {faArrowDown, faArrowUp} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
export const QuestionCheckbox = ({questions, selectedQuestions, setSelectedQuestions}) => {
    const [q, setQ] = useState("")
    const [privateSelected, setPrivateSelected] = useState([...selectedQuestions])
    const [openQuestion, setOpenQuestion] = useState(false)
    const {groupId} = useParams()
    const filteredQuestion =  (q || groupId!=="0")? questions.filter(question =>{
      return ((question.title.toLowerCase().indexOf(q.toLowerCase()) >-1)||(question.group.name.toLowerCase().indexOf(q.toLowerCase()) > -1 )) && (groupId==='0' || question.group._id === groupId )

    }) : [...questions]
    const selectQuestion = (e) => {
        if(e.target.checked){
          setPrivateSelected([...privateSelected, e.target.value])
        }else{
          setPrivateSelected(privateSelected.filter(task=>task !== e.target.value))
        }
    }

    const clearSelected = () => {
      setPrivateSelected([])
      setSelectedQuestions([])
      setOpenQuestion(false)
      setQ("")
    }
    const showSelected = () => {  
      setSelectedQuestions(privateSelected)
      setOpenQuestion(false)
    }

    const openClosePanel = () => {
      if(openQuestion){
        setOpenQuestion(false)
      
      }else{
        setOpenQuestion(true)
      }
    }
    const extLabel = openQuestion  ? <>סגור<FontAwesomeIcon icon={faArrowUp} /></> : <> לחץ לעדכון <FontAwesomeIcon icon={faArrowDown} /></>
    let label =  privateSelected.length > 0 ? <> נבחרו {privateSelected.length} שאלונים {extLabel}  </>:<>בחר שאלונים  {extLabel}  </>

  return (
    <div className="task-cb-wrapper ">
      <div className=" flex gap-2 my-2 justify-between items-center">
        <div className="flex gap-2 items-center">
 <button className="bg-white rounded p-2 w-80" onClick={openClosePanel}>{label} </button>
      <button
      disabled={!privateSelected.length}
       className={` text-white rounded p-2 w-20 text-center ${privateSelected.length? 'bg-blue-500':'bg-gray-500'}`} onClick={showSelected}> הצג </button>
        </div>
     <div className="flex gap-2 items-center">

       {openQuestion &&      <input value={q} className="rounded p-2" type="text" placeholder="חיפוש לפי משימה או לפי קבוצה" onChange={(e)=>setQ(e.target.value)} />}

     <button className="bg-white rounded p-2 justify-self-end" onClick={clearSelected}>נקה הכל</button>
  </div>
      </div>
        {openQuestion && <div className="task-cb">
        <div className="friend-list">
         {filteredQuestion.map(question=>{
           return <div key={question._id}>  <input value={question._id} checked={privateSelected.indexOf(question._id) > -1}   type="checkbox" onChange={selectQuestion}  /> {question.title} {question.group.name}   </div>
        })} 
        </div>
        </div>}
    </div>
  )
}
